(function () {
    'use strict';

    a3_cabin_reports.controller('OrderFormModalCtrl', OrderFormModalCtrl);

    /**
     * @memberof CabinReports
     * @ngdoc controller
     * @name OrderFormModalCtrl
     * @description 
     * Manages the Order Form Modal
     * @ngInject
     */
    function OrderFormModalCtrl($scope, $uibModalInstance, orderDetails, report, $routeParams, FlightOrdersFactory, CabinReportLocalEditFactory, $uibModal) {
        var flightId = parseInt($routeParams.flightId, 10); // Explicit conversion to number

        // Initialize scope variables
        $scope.order = orderDetails;
        $scope.orderNumber = orderDetails.OrderNumber;
        $scope.orderStatus = orderDetails.Status;
        $scope.feedback = orderDetails.Feedback || '';
        $scope.reason = orderDetails.Reason || null;
        $scope.photo = orderDetails.Photos || [];
        $scope.reasonError = false;

        $scope.handleReasonError = handleReasonError;
        $scope.cancel = cancel;
        $scope.save = save;
        $scope.viewPhoto = viewPhoto;
        $scope.openPhotoModal = openPhotoModal;

        // Function to handle errors in reason selection
        function handleReasonError(selectedReason) {
            if (selectedReason) {
                $scope.reason = selectedReason;
                $scope.reasonError = false;
            }
        }

        $scope.changeOrderStatus = function (status) {
            $scope.orderStatus = status; // Update the status

            if (status === 'Delivered') {
                $scope.reasonError = false; // Clear error
                $scope.reason = ''; // Reset reason
                $scope.feedback = ''; // Reset feedback
            } else if (status === 'Not Delivered') {
                $scope.reasonError = false; // Clear error
                $scope.reason = ''; // Reset reason
                $scope.feedback = ''; // Reset feedback
            }
        };

        // Function to view the attached photo
        function viewPhoto(photo) {
            if (photo && photo.PhotoData) {
                window.open(photo.PhotoData, '_blank');
            }
        }

        // Attach or replace photo logic
        $scope.attachPhoto = function () {
            // Ensure the `Photos` array exists in the order object
            if (!$scope.order.Photos) {
                $scope.order.Photos = []; // Initialize an empty array if it doesn't exist
            }

            // Directly open the photo modal without asking for confirmation
            openPhotoModal();

            // Function to open the photo modal
            function openPhotoModal() {
                const modalInstance = $uibModal.open({
                    templateUrl: 'views/Dialogs/dlgItemPhotos.html',
                    controller: 'ItemPhotosCtrl',
                    size: 'md',
                    resolve: {
                        item: function () {
                            return $scope.order; // Pass the entire `Order` object to the modal
                        }
                    }
                });

                // Handle the result from the modal
                modalInstance.result.then(
                    function () {

                    },
                    function () {
                    }
                );
            }

        }

        function openPhotoModal() {
            const modalInstance = $uibModal.open({
                templateUrl: 'views/Dialogs/dlgItemPhotos.html',
                controller: 'ItemPhotosCtrl',
                size: 'md',
                windowClass: 'custom-modal-class',
                resolve: {
                    item: function () {
                        return $scope.order; // Pass the Order object
                    }
                }
            });

            // Handle the result from the modal
            modalInstance.result.then(function (updatedItem) {
                if (updatedItem && updatedItem.Photos) {
                    $scope.order.Photos = updatedItem.Photos; // Update the Photos array
                }
            }, function () {
                console.log("Photo modal dismissed.");
            });
        }

        // Save order logic
        function save() {
            // Validate reason if the status is "Not Delivered"
            if ($scope.orderStatus === 'Not Delivered' && !$scope.reason) {
                $scope.reasonError = true;
                return;
            }

            // Update order details
            const updatedOrder = {
                OrderNumber: $scope.orderNumber,
                Status: $scope.orderStatus || 'Pending',
                Feedback: $scope.feedback || '',
                Reason: $scope.reason || '',
                Photos: $scope.order.Photos || []
            };

            // Update flattened orders
            var flattenedOrders = FlightOrdersFactory.getFlightOrdersFlattenedByFlightId(flightId);
            const existingOrder = flattenedOrders.Orders.find(order => order.OrderNumber === updatedOrder.OrderNumber);
            if (existingOrder) {
                Object.assign(existingOrder, updatedOrder);
            } else {
                flattenedOrders.Orders.push(updatedOrder);
            }
            FlightOrdersFactory.saveOrUpdateCabinReport(flightId, flattenedOrders);

            // Sync with the local report
            const report = CabinReportLocalEditFactory.getCabinReportLocalEditForFlight($scope.flightId);
            if (report) {
                if (!report.FlightOrders || !Array.isArray(report.FlightOrders.Orders)) {
                    report.FlightOrders = { Orders: [] };
                }
                const reportOrder = report.FlightOrders.Orders.find(o => o.OrderNumber === updatedOrder.OrderNumber);
                if (reportOrder) {
                    Object.assign(reportOrder, updatedOrder);
                } else {
                    report.FlightOrders.Orders.push(updatedOrder);
                }
                report.updateTotals();
                report.saveReport();
            }

            // Close the modal
            $uibModalInstance.close(updatedOrder);
        }

        // Cancel the modal
        function cancel() {
            $uibModalInstance.close(false);
        }

        $scope.deletedPhoto = null; // Store the last deleted photo temporarily
        $scope.deletedPhotoIndex = null; // Store the index of the deleted photo

        // Function to delete a photo
        $scope.deletePhoto = function (index) {
            $scope.deletedPhoto = $scope.order.Photos[index]; // Save the deleted photo
            $scope.deletedPhotoIndex = index; // Save the index
            $scope.order.Photos.splice(index, 1); // Remove the photo
        };
    }
})();
